/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var self = ezdia.pages.projects;
    var orgNameCol = {
        orgName: {
            label: 'Organization Name',
            field: 'orgName',
            fieldType: 'text',
            editable: true,
            config: {
                validate_rules: {
                    required: true
                }
            }
        }
    };
    function resetView() {
        hideShowDeskForm();
        $.ezdia.quickLinks.triggersOff('#ez-quick-action-links');
        $('#grid').trigger('reloadGrid');
        $('#quickactionfield').empty();
        $('#updateBtnContainer').hide();
    }
    function toggleQuickLinks(selIds, clicked) {
        var id = this.id;
        var checked = $("#cb_" + id).is(':checked');
        if (!selIds.length) {
            $.ezdia.quickLinks.triggersOff('#ez-quick-action-links');
        }
        else if ((selIds.length === 1 && clicked) || checked) {
            $.ezdia.quickLinks.triggersOn('#ez-quick-action-links');
        }
    }
    function cloneAccount() {
        var activeBtn = $(this);
        activeBtn.button('cloning');
        var frm = $('#bulkEditFrm');
        var valid = frm.valid();
        if (!valid) {
            activeBtn.button('reset');
            return;
        }
        var data = frm.serialize();
        $.ajax({
            type: 'POST',
            url: 'CloneAccount.htm',
            dataType: 'json',
            data: data,
            success: function (response) {
                if (response.success) {
                    ezdia.util.showSuccessError({
                        message: response.msg
                    });
                    resetView();
                }
                else {
                    var obj = {
                        response: response.msg,
                        success: response.success,
                        url: ''
                    };
                    successErrorDialog(obj);
                }
            },
            error: function (response) {
                var obj = {
                    response: response,
                    success: false,
                    url: ''
                };
                successErrorDialog(obj);
            }
        }).always(function () {
            activeBtn.button('reset');
        });
    }
    var Projects = /** @class */ (function () {
        function Projects() {
        }
        Projects.prototype.load = function () {
            this.init();
            this.render();
        };
        Projects.prototype.createNew = function () {
            var _this = this;
            var pageParams = $.ezdia.config.pageParams;
            var colModel = pageParams.colModel, formType = pageParams.formType, defaultEmail = pageParams.defaultEmail;
            $.ezdia.validate.all(colModel, 'createaccount');
            $.ezdia.widgets.renderAll(colModel, formType);
            if (defaultEmail) {
                this.setDefaultPMEmail();
            }
            var createBtn = $('#ez-js-create-account-btn');
            createBtn.on('click', function () {
                _this.handelCreateAccount(createBtn);
            });
            pageLoadingDone();
        };
        Projects.prototype.init = function () {
            self = ezdia.pages.projects;
            this.cache = {
                editfrm: $('#ez-edit-store-form'),
                editfrmCol: $('#ez-edit-store-form-col'),
                editfrminputs: $('#ez-edit-store-form-inputs'),
                bulkEditFrm: $('#bulkEditFrm'),
                quickactionfield: $('#quickactionfield'),
                updateBtn: $('#ez-edit-store-form-update'),
                cloneAccountFrm: $('#ez-clone-account-form'),
                cloneAccountFrmCol: $('#ez-clone-account-form-col'),
                cloneAccountFrmInputs: $('#ez-clone-account-form-inputs')
            };
        };
        Projects.prototype.render = function () {
            this.search();
            this.grid();
            this.quickAction();
            this.actions();
            ezdia.component.form.closeFormBtn('ez-js-form-right-close');
            $('#ez-project-nav').scrollingNav();
            pageLoadingDone();
            $.ezdia.stickyFormBtns({
                sticky: 'editForm-main',
                frm: 'ez-edit-store-form'
            });
        };
        Projects.prototype.search = function () {
            var pageParams = $.ezdia.config.pageParams;
            var colModel = $.ezdia.config.pageParams.colModel;
            var searchFieldsJson = {};
            $.each(colModel, function (i, column) {
                searchFieldsJson[column.name] = column;
            });
            pageParams.searchFieldsJson = searchFieldsJson;
            $.ezdia.initGenericSearch('#searchFrm', ezdia.pages.storeForm.export, 'searchData.htm');
        };
        Projects.prototype.grid = function () {
            var rowNum = 10;
            var pageParams = $.ezdia.config.pageParams;
            var account = pageParams.account, formType = pageParams.formType, colModel = pageParams.colModel, colNames = pageParams.colNames, isGridMultiselect = pageParams.isGridMultiselect;
            ezdia.component.grid.create({
                id: 'grid',
                url: 'AccountData.htm',
                datatype: 'json',
                mtype: 'POST',
                postData: {
                    formtype: function () {
                        return formType;
                    },
                    accountName: function () {
                        return account;
                    },
                    searchCondition: function () {
                        return $('#searchFrm').search('getQueryString');
                    }
                },
                colModel: colModel,
                colNames: colNames,
                rowNum: rowNum,
                multiselect: isGridMultiselect,
                onSelectRow: this.onSelectRow,
                onSelectAll: this.onSelectRow,
                loadComplete: this.loadComplete,
                caption: 'Projects',
                searchFrm: '#searchFrm',
                customeBtnsWrapId: 'ez-js-grid-actions-btns',
                hidegrid: false,
                gridview: true
            });
        };
        Projects.prototype.onSelectRow = function (ids, clicked) {
            var grid = $(this);
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            var deselectrow = grid.jqGrid('getGridParam', 'deselectrow');
            if ((selIds && selIds.length > 1) || deselectrow) {
                hideShowDeskForm('#bulkEditFrm');
                ezdia.component.form.show();
                if (deselectrow) {
                    grid.jqGrid('resetSelection');
                    grid.jqGrid('setGridParam', { deselectrow: false });
                }
            }
            else if (ids && clicked) {
                ezdia.component.form.show();
                ezdia.pages.storeForm.resetSelectedRow.call(self);
                ezdia.pages.storeForm.form.call(self, ids);
            }
            else if (!selIds.length) {
                ezdia.component.form.hide();
                hideShowDeskForm('');
            }
            toggleQuickLinks.call(this, selIds, clicked);
        };
        Projects.prototype.loadComplete = function () {
            var pageParams = $.ezdia.config.pageParams;
            var $grid = $('#grid');
            var recordCount = $grid.jqGrid('getGridParam', 'records');
            var rowNum = $grid.jqGrid('getGridParam', 'rowNum');
            var gridCaption = pageParams.gridCaption || 'Projects';
            if (pageParams.isGridMultiselect && recordCount > rowNum) {
                gridCaption = ezdia.templates.grid.countAndSelectCaption(recordCount);
            }
            gridCaption = ezdia.templates.grid.caption(gridCaption);
            $grid.jqGrid('setCaption', gridCaption);
            hideShowDeskForm('#bulkEditFrm');
            ezdia.component.form.hide();
            setGridCellTitle();
            if (pageParams.sysSelectFirst) {
                $.ezdia.grid.selectFirstItem('#grid');
            }
        };
        Projects.prototype.postrenderQA = function () {
            var ids = getGridSelRow();
            var rowData = $('#grid').jqGrid('getRowData', ids);
            var accNm = getColDataString('', rowData.name);
            var frm = $('#bulkEditFrm');
            var qaBtn = frm.find('button[data-qa-type]');
            var qaType = qaBtn.data('qaType');
            var cloneToOrg = qaType === 'sys_clone_org_account' ? 'true' : 'false';
            $('#quickactionfield').append("\n        <input type='hidden' name='accountName' value='" + accNm + "'/>\n        <input type='hidden' name='cloneAccToOrg' value='" + cloneToOrg + "'/>\n        <input type=\"hidden\" id=\"action\" name=\"action\" value=\"clone\"/>\n      ");
            qaBtn.off('click').on('click', cloneAccount);
        };
        Projects.prototype.quickAction = function () {
            var e_1, _a;
            var fieldsArray = ['label', 'acc_status', 'pm_email'];
            var pageParams = $.ezdia.config.pageParams;
            var colModel = pageParams.colModel, quickactionObj = pageParams.quickactionObj, isCloneOrgAccount = pageParams.isCloneOrgAccount, isCloneAccount = pageParams.isCloneAccount;
            var listItems = '';
            var arr = [];
            var quickActionFields = {};
            var colModelCopy = __spread(colModel);
            $.ezdia.postrender = $.ezdia.postrender || {};
            $.ezdia.postrender.sys_clone_org_account = this.postrenderQA;
            $.ezdia.postrender.sys_clone_account = this.postrenderQA;
            try {
                for (var colModelCopy_1 = __values(colModelCopy), colModelCopy_1_1 = colModelCopy_1.next(); !colModelCopy_1_1.done; colModelCopy_1_1 = colModelCopy_1.next()) {
                    var col = colModelCopy_1_1.value;
                    var name_1 = col.name;
                    if (fieldsArray.includes(name_1)) {
                        delete col.addon;
                        delete col.value;
                        col.field = name_1;
                        col.fieldType = col.edittype;
                        col.config = __assign(__assign({}, col.config), { validate_rules: {
                                required: true
                            } });
                        quickActionFields[name_1] = col;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (colModelCopy_1_1 && !colModelCopy_1_1.done && (_a = colModelCopy_1.return)) _a.call(colModelCopy_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (isCloneOrgAccount) {
                arr.push({
                    actionUrl: 'CloneAccount.htm',
                    btnlabel: 'Clone Org',
                    name: 'sys_clone_org_account',
                    type: 'sys_clone_org_account',
                    id: 'sys_clone_org_account',
                    label: 'Clone to another Organization',
                    minItems: 1,
                    disabled: true,
                    quickActionFields: __assign(__assign({}, orgNameCol), quickActionFields)
                });
            }
            if (isCloneAccount) {
                arr.push({
                    actionUrl: 'CloneAccount.htm',
                    btnlabel: 'Clone Account',
                    name: 'sys_clone_account',
                    type: 'sys_clone_account',
                    id: 'sys_clone_account',
                    label: 'Clone Account',
                    minItems: 1,
                    disabled: true,
                    quickActionFields: quickActionFields
                });
            }
            pageParams.quickactionObj = __spread(arr);
            listItems = $.ezdia.quickLinks.create(quickactionObj, arr, true);
            if (listItems) {
                $('#qactiondiv').html(listItems);
                $.ezdia.quickLinks.triggersActive('#ez-quick-action-links');
            }
            $.ezdia.showMorelinks();
        };
        Projects.prototype.setDefaultPMEmail = function () {
            var pageParams = $.ezdia.config.pageParams;
            var defaultEmailType = pageParams.defaultEmailType;
            if (defaultEmailType === 'groupField') {
                var pmEmail = $('#pm_email');
                pmEmail.val("[{\"value\": \"" + pageParams.email + "\"}]");
                pmEmail.inputList('refresh', [
                    { value: pageParams.email },
                    { value: '' }
                ]);
            }
            else {
                var container = $('#pm_email-main').find('[data-container="groupfield"]');
                var elem = container.find('[data-path="groupFields"]');
                elem.val(pageParams.email).trigger('change');
                container.find('[data-btn="add"]').trigger('click');
            }
        };
        Projects.prototype.actions = function () {
            this.cache.updateBtn.on('click', this.update.bind(this));
            $('#ez-edit-store-form-cancel').on('click', this.cancel.bind(this));
        };
        Projects.prototype.update = function () {
            var _a = this.cache, editfrm = _a.editfrm, btn = _a.updateBtn;
            btn.button('loading');
            if (!editfrm.valid()) {
                btn.button('reset');
                return false;
            }
            editfrm
                .ajaxForm({
                success: function (response) {
                    btn.button('reset');
                    if (response.success) {
                        ezdia.util.showSuccessError({
                            message: response.msg
                        });
                        editfrm.localStorage('discard');
                        editfrm.hide();
                        resetView();
                    }
                    else {
                        ezdia.util.showSuccessError({
                            message: response.msg,
                            error: true,
                            autohide: false
                        });
                    }
                },
                error: function (response) {
                    btn.button('reset');
                    ezdia.util.showSuccessError({
                        message: response,
                        error: true,
                        autohide: false
                    });
                }
            })
                .submit();
            return false;
        };
        Projects.prototype.handelCreateAccount = function (btn) {
            if ($('#createaccount').valid()) {
                var data = $('#createaccount').serialize();
                if (btn) {
                    btn.button('loading');
                }
                $.ajax({
                    type: 'POST',
                    url: 'SubmitAccount.htm',
                    data: data,
                    dataType: 'json',
                    success: function (response) {
                        if (response.success) {
                            var accountName = response.accountName;
                            window.location.href = CONTEXT_ROOT + "/desk/CreateProjectSuccess.htm?accountName=" + accountName;
                        }
                        else {
                            ezdia.util.showSuccessError({
                                autohide: false,
                                error: true,
                                message: response.msg
                            });
                        }
                        btn.button('reset');
                    },
                    error: function (response) {
                        ezdia.util.showSuccessError({
                            autohide: false,
                            error: true,
                            message: response.msg
                        });
                        btn.button('reset');
                    }
                });
            }
        };
        Projects.prototype.cancel = function () {
            var _a = this.cache, editfrm = _a.editfrm, editfrminputs = _a.editfrminputs;
            editfrm.hide();
            editfrminputs.empty();
            $('#message').html('');
        };
        return Projects;
    }());
    var pages;
    (function (pages) {
        pages.projects = new Projects();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
